<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Permitted Credit Card List</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="cardListCode" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.cardListCode }}</td>
        <td class="text-xs-left">{{ props.item.cardListDesc }}</td>
        <td class="text-xs-right">
          <table-action :rowData="props" remove @remove="doPromptRemove(props.item)" :loading="loading"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-card-text>
      <v-btn slot="activator" color="primary" dark class="mb-2" @click="doNew()">
        Permit Credit Card List
        <v-icon right>mdi-credit-card-multiple</v-icon>
      </v-btn>
      <v-btn slot="activator" color="secondary" dark class="mb-2" @click="doAddCrCdList()">
        Add Credit Card List
        <v-icon right>mdi-credit-card-plus</v-icon>
      </v-btn>
    </v-card-text>
    <v-dialog v-model="addCardListDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Permit Credit Card List for Promotion</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete :label="labels.cardListCode" v-model="promoCrCdForm.cardListCode" :items="cardList" item-text="label" item-value="value" :error-messages="errors.collect('cardListCode')" data-vv-name="cardListCode" :data-vv-as="labels.cardListCode" v-validate="'required'" :loading="cardListCodeLoading"></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Permitted Credit Card List?
      <div class="title">{{deletePromoCrCd}}</div>
    </confirm>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      headers: [
        { text: 'Card List Code', align: 'left', value: 'cardListCode', sortable: false },
        { text: 'Card List Description', align: 'left', value: 'cardListDesc', sortable: false },
        TableConst.tableActionHeader
      ],
      labels: {
        cardListCode: 'Card List Code*'
      },
      promoCrCdForm: {
        promotion: undefined,
        cardListCode: undefined
      },
      totalItems: 0,
      loading: false,
      items: [],
      addCardListDialog: false,
      cardListCodeLoading: false,
      cardList: [],
      promptRemove: false,
      selectedPromoCrCd: undefined,
      deletePromoCrCd: ''
    }
  },
  methods: {
    async doInit() {
      this.promoCrCdForm.promotion = this.promotion
      await this.queryPromotionCreditCards()
    },
    async queryPromotionCreditCards() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionCreditCards
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            promotion: this.promotion
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((promotionCreditCard) => {
                const convertPromotionCreditCard = {
                  promotion: promotionCreditCard.promotion,
                  promotionDesc: promotionCreditCard.promotionDesc,
                  cardListCode: promotionCreditCard.cardListCode,
                  cardListDesc: promotionCreditCard.cardListDesc
                }
                this.items.push(convertPromotionCreditCard)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getCardListCodes() {
      this.cardListCodeLoading = true
      if (this.$store.state.promotionManagement.promotion.cardList && this.$store.state.promotionManagement.promotion.cardList.length > 0) {
        let result = []
        result = this.$store.state.promotionManagement.promotion.cardList
        // Remove those that already permitted
        result = result.filter(cardListCode => {
          for (let permittedCardListCode of this.items) {
            if (permittedCardListCode.cardListCode === cardListCode.value) {
              return false
            }
          }
          return true
        })
        this.cardList = result
      } else {
        this.cardList = []
      }
      this.cardListCodeLoading = false
    },
    doSave() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doCreate()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doNew() {
      this.resetMessages()
      this.promoCrCdForm.cardListCode = undefined
      this.addCardListDialog = true
      this.getCardListCodes()
    },
    async doCreate() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionCreditCardCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.promoCrCdForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            this.doClose()
            // Fetch list again
            this.queryPromotionCreditCards()
          }
          this.submitting = false
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doClose() {
      this.resetMessages()
      this.promoCrCdForm.cardListCode = undefined
      this.addCardListDialog = false
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedPromoCrCd = data
        this.deletePromoCrCd = data.cardListCode + ' - ' + data.cardListDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionCreditCardDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          promotion: this.promotion,
          cardListCode: this.selectedPromoCrCd.cardListCode
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.queryPromotionCreditCards()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doAddCrCdList() {
      this.$router.push({ name: 'creditCardLists' })
    }
  },
  props: {
    promotion: {
      type: String,
      default: ''
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
